import { config } from "./config";

export const ScheduleSearchResults = () => {
    function getDomReferences() {
        return {
            scheduleNav: document.querySelector(".schedule-nav"),
            scheduleNavItems: document.querySelectorAll(".schedule-nav__item"),
            scheduleContent: document.querySelector(".schedule-content"),
            scheduleContentItems: document.querySelectorAll(".schedule-content__item"),
        };
    }

    function generateScheduleSectionsIds(schedulesContentItems) {
        schedulesContentItems.forEach((item) =>
            item.setAttribute(
                config.scheduleSearchIdAttr,
                config.scheduleSearchIdAttr + "-" + Math.floor(Math.random() * 100000)
            )
        );
    }

    function updateResultsCountInGroup({ scheduleCard }, resultsGrouped) {
        const relatedScheduleContentItem = scheduleCard.closest(".schedule-content__item");
        const scheduleContentItemId = relatedScheduleContentItem.getAttribute(config.scheduleSearchIdAttr);

        resultsGrouped[scheduleContentItemId]
            ? resultsGrouped[scheduleContentItemId]++
            : (resultsGrouped[scheduleContentItemId] = 1);

        return resultsGrouped;
    }

    function activateSlotForSearchResults(scheduleCard) {
        scheduleCard.closest(config.scheduleSlot).classList.add(config.scheduleSlotSearchActiveClass);
    }

    function clearActiveSlots() {
        document
            .querySelectorAll(`.${config.scheduleSlotSearchActiveClass}`)
            .forEach((slot) => slot.classList.remove(config.scheduleSlotSearchActiveClass));
    }

    function clearSearchActiveCards() {
        document
            .querySelectorAll(`.${config.scheduleCardSearchActiveClass}`)
            .forEach((card) => card.classList.remove(config.scheduleCardSearchActiveClass));
    }

    function clearBadgesCount(scheduleNavItems) {
        scheduleNavItems.forEach((navItem) => {
            navItem.querySelector(config.scheduleNavBadge).innerText = "";
        });
    }

    return {
        resultsGrouped: {},
        elements: getDomReferences(),
        getResultsCount() {
            return Object.keys(this.resultsGrouped).reduce((acc, current) => {
                acc += this.resultsGrouped[current];
                return acc;
            }, 0);
        },
        getTotalResultsCount() {
            return document.querySelectorAll(".profile-card-small").length;
        },
        initialize() {
            generateScheduleSectionsIds(this.elements.scheduleContentItems);
        },
        displayResults(jobId) {
            this.clearResults();

            const scheduleCardsWithJob = this.elements.scheduleContent.querySelectorAll(`[${config.scheduleJobAttr}]`);
            scheduleCardsWithJob.forEach((scheduleCard) => {
                const scheduleCardJobId = scheduleCard.getAttribute(config.scheduleJobAttr);
                if (scheduleCardJobId === jobId) {
                    scheduleCard.classList.add(config.scheduleCardSearchActiveClass);
                    activateSlotForSearchResults(scheduleCard);
                    this.resultsGrouped = updateResultsCountInGroup({ scheduleCard }, this.resultsGrouped);
                }
            });

            this.elements.scheduleNav.classList.add(config.scheduleNavSearchActiveClass);
            this.elements.scheduleContent.classList.add(config.scheduleContentSearchActiveClass);
        },
        updateBadgesCount() {
            const scheduleContainers = this.elements.scheduleContent.querySelectorAll(
                `[${config.scheduleSearchIdAttr}]`
            );
            scheduleContainers.forEach((scheduleContainer, index) => {
                const scheduleContainerId = scheduleContainer.getAttribute(config.scheduleSearchIdAttr);
                const scheduleSearchCount = this.resultsGrouped[scheduleContainerId];
                const badgeElement = this.elements.scheduleNavItems[index].querySelector(config.scheduleNavBadge);
                if (badgeElement && scheduleSearchCount) {
                    badgeElement.innerText = scheduleSearchCount;
                }
            });
        },
        clearResults() {
            this.elements.scheduleNav.classList.remove(config.scheduleNavSearchActiveClass);
            this.elements.scheduleContent.classList.remove(config.scheduleContentSearchActiveClass);
            this.resultsGrouped = {};
            clearActiveSlots();
            clearBadgesCount(this.elements.scheduleNavItems);
            clearSearchActiveCards();
        },
    };
};
